/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Square = [
  "svg",
  defaultAttributes,
  [["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }]]
];

export { Square as default };
//# sourceMappingURL=square.js.map
